module.exports = __webpack_public_path__ + "img/m_cc.05f65b4a.png";